export default {
  device: {
    sensor: '传感器',
    gateway: '网关',
    display: '显示屏',
    relay: '中继',
    sensor_code: '传感器编号',
    sensor_type: '传感器类型',
    sensor_status: '传感器状态',
    transmit_power: '发射功率',
    channel_mask: '信道掩码',
    in_net_interval: '入网间隔(秒)',
    sample_interval: '采集间隔(秒)',
    current_probe_value: '当前探测值',
    exception_sample_interval: '异常采集间隔(秒)',
    temp_sample_interval: '温度采集间隔',
    hum_sample_interval: '湿度采集间隔',
    temp_change_threshold: '温度变化阈值',
    hum_change_threshold: '湿度变化阈值',
    max_temp_report_interval: '温度最大上报间隔',
    max_hum_report_interval: '湿度最大上报间隔',
    min_temp_report_interval: '温度最小上报间隔',
    min_hum_report_interval: '湿度最小上报间隔',
    forward_gateway: '转发网关',
    high_temp: '高温',
    low_temp: '低温',
    config_log: '配置日志',
    running_status: '状态',
    gateway_name: '网关名称',
    display_name: '显示屏名称',
    display_nickname: '显示屏昵称',
    gateway_nickname: '网关昵称',
    gateway_type: '网关类型',
    gateway_status: '网关状态',
    mac_address: 'mac地址',
    associated_gateway_details: '关联网关详情',
    long_addr: '长地址',
    short_addr: '短地址',
    activated: '是否已激活',
    gateway_serial_num: '网关序列号',
    belong_carrier: '资产',
    zigbee_param_status: 'zigbee参数状态',
    power_status: '电源状态',
    tcp_conn_status: 'TCP连接状态',
    lte_conn_status: 'LTE连接状态',
    flight_mode: '飞行模式',
    no_flight_mode: '不是飞行模式',
    self_ip: '自身IP属性',
    gateway_no_report: '网关还没有获取到网关Zigbee的相关参数',
    gateway_normal: '网关正常上报数据',

    no_power_supply: '备电工作',
    normal_power_supply: '供电正常',
    conn_normal: '连接正常',
    conn_abnormal: '连接异常',
    LTE_conn_normal: 'LTE连接正常',
    LTE_conn_abnormal: 'LTE连接异常',
    add_net_param: '新增网络参数',
    reuse: '重新使用',
    modify_customer: '编辑公司',
    import_data: '数据导入',
    relay_number: '中继编号',
    relay_type: '中继类型',
    display_type: '显示屏类型',
    display_number: '显示屏编号',
    wait_config: '等待配置',
    configuring: '正在配置',
    configured: '已经配置',
    heartbeat_history: '心跳历史',
    config_status: '配置状态',
    gateway_mac: '网关mac',
    heartbeat_on: '心跳记录开启',
    stop_time: '停用时间',
    time_zone: '时区',
    alarm_on: '报警',
    alarm_off: '关闭报警',
    nickname: '昵称',
    history_data: '历史数据',
    stop_use: '停用',

    zoom: '缩放',
    device_location: '探测关联设备定位',
    upload_carrier_img: '请上传资产图片',
    select_img: '选择图片',
    upload: '确定上传',
    tip_before_location: '请先上传图片再进行定位',

    temp_range: '温度区间',
    hum_range: '湿度区间',
    temp_val: '温度值',
    hum_val: '湿度值',
    sample_value: '采集值',

    calibration_expiration_date: '录入校准到期日期',
    calibration_notice: '校准通知',
    add_notification_object: '新增通知对象',
    advance: '提前',
    notice: '通知',
    calibration_expiration: '校准到期',
    import_calibration_info: '导入校准信息',
    download_calibration: '点击下载校准模板',
    start_calibration: '开启校准验证',
    no_calibration: '免校准',
    calibration_notice_time_tips: '校准通知时间不能在当前时间之前',
    no_set_calibration: '未设置校准',

    switch_type: '切换方式',
    intelligent_switch: '智能切换',
    manual_switch: '人工切换',
    direct_switch: '直接切换',
    cancel_switch: '切换取消',
    intelligent_switch_desc: '系统将会自动监测切换设备是否达到原设备的安装位置条件，待达到后，系统将会自动切换设备',
    manual_switch_desc: '系统将切换的时机交给用户自行决定',
    direct_switch_desc: '跳过所有流程，直接切换选中的设备',
    cancel_switch_desc: '填写>=0数字，如果切换操作超出此时间，系统将会恢复原来设置，填写0或不填写代表永不过时',
    remaining_switch_time: '剩余切换时间',
    switch_operation: '切换操作',
    start_switch: '开始切换',
    history: '历史',
    switch_now: '是否立即启动设备切换？',
    stop_switch: '终止切换',
    complete_switch: '完成切换',
    switch: '切换',
    not_reached: '未达到切换条件',
    eligible: '符合条件',
    user_switch: '用户切换',
    ignore_switch: '无视条件切换',
    user_stop: '用户终止',
    switch_result_notice: '切换结果通知',
    device_switch_notice: '设备切换通知',
    time: '用时',
    switch_carrierName_tips: '系统检测到切换的设备已关联安装位置，是否解绑安装位置进行切换操作?',
    device_not_bind: '暂未绑定设备',
    please_enter_sample_interval: '请输入采集间隔',
    normal_reporting_interval: '正常上报间隔(秒)',
    please_enter_normal_reporting_interval: '请输入正常上报间隔',
    abnormal_reporting_interval: '异常上报间隔(秒)',
    please_enter_abnormal_reporting_interval: '请输入异常上报间隔',
    async_reporting_interval: '同步上报间隔(秒)',
    fixed_reporting_interval: '固定上报间隔(秒)',
    async_sample_interval: '同步采集间隔(秒)',
    max_recording_interval: '最大记录间隔(秒)',
    min_recording_interval: '最小记录间隔(秒)',
    max_change_amount: '最大变化量',
    alarm_level: '报警级别',
    sample_mode: '采集模式',
    fix_sample_interval: '固定采集间隔(秒)',

    // 时区，根据接口数据时区的code划分
    '0': '中时区',
    '+1': '东一区',
    '+2': '东二区',
    '+3': '东三区',
    '+4': '东四区',
    '+5': '东五区',
    '+6': '东六区',
    '+7': '东七区',
    '+8': '东八区',
    '+9': '东九区',
    '+10': '东十区',
    '+11': '东十一区',
    '+12': '东十二区',
    '-1': '西一区',
    '-2': '西二区',
    '-3': '西三区',
    '-4': '西四区',
    '-5': '西五区',
    '-6': '西六区',
    '-7': '西七区',
    '-8': '西八区',
    '-9': '西九区',
    '-10': '西十区',
    '-11': '西十一区',
    '-12': '西十二区',

  }
}
